module.exports = __webpack_public_path__ + "img/topbar-iconic.svg";